import {
  BaseFlowBlockSchema,
  FlowBlockReturnTypeSchema,
  FlowBlockType,
  FlowProducedType,
} from 'flow-schema';
import { DocumentTemplateDataSourceApiKey } from 'primary-schema';
import { z } from 'zod';

export enum GenerateDocumentMode {
  DocumentTemplate = 'DocumentTemplate',
  Markdown = 'Markdown',
  CombinePdf = 'CombinePdf',
}

// Generate the schema dynamically
export const DocumentTemplateBlockConfigSchema = z.discriminatedUnion('generateDocumentMode', [
  z.object({
    generateDocumentMode: z.literal(GenerateDocumentMode.DocumentTemplate),
    documentTemplateId: z.uuid(),
    valuesByDocumentTemplateKey: z.partialRecord(
      z.enum(DocumentTemplateDataSourceApiKey),
      z.string().optional()
    ),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.FileReference),
  }),
  z.object({
    generateDocumentMode: z.literal(GenerateDocumentMode.Markdown),
    markdown: z.string(),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.FileReference),
  }),
  z.object({
    generateDocumentMode: z.literal(GenerateDocumentMode.CombinePdf),
    fileReferences: z.string(),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.FileReference),
  }),
]);

export type DocumentTemplateBlockConfig = z.infer<typeof DocumentTemplateBlockConfigSchema>;

export const DocumentTemplateBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(FlowBlockType.DocumentTemplate),
  returnType: FlowBlockReturnTypeSchema(FlowProducedType.FileReference),
  config: DocumentTemplateBlockConfigSchema,
});

export type DocumentTemplateBlock = z.infer<typeof DocumentTemplateBlockSchema>;
